import type { Property } from '@/lib/api/clients/properties';

/**
 * Mock property data for development and fallback scenarios
 * This data is used when the Route Royal API is not available
 */
export const mockProperties: Property[] = [
  {
    id: '1',
    name: 'Modern Downtown Apartment',
    description: 'Beautiful modern apartment in the heart of downtown with stunning city views.',
    status: 'ACTIVE',
    organisationId: 'org-1',
    locationId: 'loc-1',
    propertyTypeId: 'type-1',
    managedAssetId: 'asset-1',
    reference: 'REF-001',
    currentOwnerUserId: null,
    primaryAgentId: null,
    bedrooms: 3,
    bathrooms: 2,
    loungeRoomCount: 1,
    toiletCount: 2,
    garageCount: 1,
    carportCount: 0,
    openParkingCount: 0,
    parkingSpaces: 1,
    storeys: 1,
    floorNumber: 10,
    totalFloorArea: 1200,
    totalFloorAreaUnit: 'SQFT',
    landArea: null,
    landAreaUnit: null,
    yearBuilt: 2020,
    yearRenovated: null,
    condition: null,
    aspect: null,
    viewType: null,
    titleType: null,
    zoningCategory: null,
    conservationArea: false,
    primaryCertificationRating: null,
    epcExpiryDate: null,
    currency: 'USD',
    primaryImageUrl: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop',
    heroMedia: null,
    mediaLinks: [],
    attributeValues: {
      askingPrice: {
        attributeId: 'attr-1',
        attributeCode: 'askingPrice',
        attributeName: 'Asking Price',
        valueType: 'number',
        valueNumber: 1200000,
        valueString: null,
        valueBoolean: null,
        valueText: null,
        valueDate: null,
        valueStringArray: null,
      },
    },
    createdById: 'user-1',
    updatedById: 'user-1',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '2',
    name: 'Luxury Penthouse',
    description: 'Stunning penthouse with panoramic views and premium finishes throughout.',
    status: 'ACTIVE',
    organisationId: 'org-1',
    locationId: 'loc-1',
    propertyTypeId: 'type-1',
    managedAssetId: 'asset-2',
    reference: 'REF-002',
    currentOwnerUserId: null,
    primaryAgentId: null,
    bedrooms: 4,
    bathrooms: 3,
    loungeRoomCount: 2,
    toiletCount: 3,
    garageCount: 2,
    carportCount: 0,
    openParkingCount: 0,
    parkingSpaces: 2,
    storeys: 1,
    floorNumber: 25,
    totalFloorArea: 2500,
    totalFloorAreaUnit: 'SQFT',
    landArea: null,
    landAreaUnit: null,
    yearBuilt: 2018,
    yearRenovated: 2022,
    condition: null,
    aspect: null,
    viewType: null,
    titleType: null,
    zoningCategory: null,
    conservationArea: false,
    primaryCertificationRating: null,
    epcExpiryDate: null,
    currency: 'USD',
    primaryImageUrl: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop',
    heroMedia: null,
    mediaLinks: [],
    attributeValues: {
      askingPrice: {
        attributeId: 'attr-1',
        attributeCode: 'askingPrice',
        attributeName: 'Asking Price',
        valueType: 'number',
        valueNumber: 3500000,
        valueString: null,
        valueBoolean: null,
        valueText: null,
        valueDate: null,
        valueStringArray: null,
      },
    },
    createdById: 'user-1',
    updatedById: 'user-1',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '3',
    name: 'Cozy Starter Home',
    description: 'Charming starter home perfect for first-time buyers or small families.',
    status: 'ACTIVE',
    organisationId: 'org-1',
    locationId: 'loc-1',
    propertyTypeId: 'type-1',
    managedAssetId: 'asset-3',
    reference: 'REF-003',
    currentOwnerUserId: null,
    primaryAgentId: null,
    bedrooms: 2,
    bathrooms: 1,
    loungeRoomCount: 1,
    toiletCount: 1,
    garageCount: 1,
    carportCount: 0,
    openParkingCount: 0,
    parkingSpaces: 1,
    storeys: 1,
    floorNumber: 1,
    totalFloorArea: 900,
    totalFloorAreaUnit: 'SQFT',
    landArea: 1500,
    landAreaUnit: 'SQFT',
    yearBuilt: 1995,
    yearRenovated: 2010,
    condition: null,
    aspect: null,
    viewType: null,
    titleType: null,
    zoningCategory: null,
    conservationArea: false,
    primaryCertificationRating: null,
    epcExpiryDate: null,
    currency: 'USD',
    primaryImageUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=600&fit=crop',
    heroMedia: null,
    mediaLinks: [],
    attributeValues: {
      askingPrice: {
        attributeId: 'attr-1',
        attributeCode: 'askingPrice',
        attributeName: 'Asking Price',
        valueType: 'number',
        valueNumber: 850000,
        valueString: null,
        valueBoolean: null,
        valueText: null,
        valueDate: null,
        valueStringArray: null,
      },
    },
    createdById: 'user-1',
    updatedById: 'user-1',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '4',
    name: 'Waterfront Estate',
    description: 'Magnificent waterfront estate with private dock and pristine landscaping.',
    status: 'ACTIVE',
    organisationId: 'org-1',
    locationId: 'loc-1',
    propertyTypeId: 'type-1',
    managedAssetId: 'asset-4',
    reference: 'REF-004',
    currentOwnerUserId: null,
    primaryAgentId: null,
    bedrooms: 5,
    bathrooms: 4,
    loungeRoomCount: 3,
    toiletCount: 4,
    garageCount: 3,
    carportCount: 0,
    openParkingCount: 0,
    parkingSpaces: 3,
    storeys: 2,
    floorNumber: 1,
    totalFloorArea: 5000,
    totalFloorAreaUnit: 'SQFT',
    landArea: 10000,
    landAreaUnit: 'SQFT',
    yearBuilt: 2015,
    yearRenovated: null,
    condition: null,
    aspect: null,
    viewType: null,
    titleType: null,
    zoningCategory: null,
    conservationArea: false,
    primaryCertificationRating: null,
    epcExpiryDate: null,
    currency: 'USD',
    primaryImageUrl: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop',
    heroMedia: null,
    mediaLinks: [],
    attributeValues: {
      askingPrice: {
        attributeId: 'attr-1',
        attributeCode: 'askingPrice',
        attributeName: 'Asking Price',
        valueType: 'number',
        valueNumber: 7500000,
        valueString: null,
        valueBoolean: null,
        valueText: null,
        valueDate: null,
        valueStringArray: null,
      },
    },
    createdById: 'user-1',
    updatedById: 'user-1',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: '5',
    name: 'Modern Loft',
    description: 'Contemporary loft conversion in historic building with exposed brick.',
    status: 'ACTIVE',
    organisationId: 'org-1',
    locationId: 'loc-1',
    propertyTypeId: 'type-1',
    managedAssetId: 'asset-5',
    reference: 'REF-005',
    currentOwnerUserId: null,
    primaryAgentId: null,
    bedrooms: 2,
    bathrooms: 2,
    loungeRoomCount: 1,
    toiletCount: 2,
    garageCount: 0,
    carportCount: 0,
    openParkingCount: 1,
    parkingSpaces: 1,
    storeys: 1,
    floorNumber: 3,
    totalFloorArea: 1100,
    totalFloorAreaUnit: 'SQFT',
    landArea: null,
    landAreaUnit: null,
    yearBuilt: 1920,
    yearRenovated: 2019,
    condition: null,
    aspect: null,
    viewType: null,
    titleType: null,
    zoningCategory: null,
    conservationArea: false,
    primaryCertificationRating: null,
    epcExpiryDate: null,
    currency: 'USD',
    primaryImageUrl: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&h=600&fit=crop',
    heroMedia: null,
    mediaLinks: [],
    attributeValues: {
      askingPrice: {
        attributeId: 'attr-1',
        attributeCode: 'askingPrice',
        attributeName: 'Asking Price',
        valueType: 'number',
        valueNumber: 950000,
        valueString: null,
        valueBoolean: null,
        valueText: null,
        valueDate: null,
        valueStringArray: null,
      },
    },
    createdById: 'user-1',
    updatedById: 'user-1',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
